import { render, staticRenderFns } from "./choosePrivilege.vue?vue&type=template&id=32b4a930&"
import script from "./choosePrivilege.vue?vue&type=script&lang=js&"
export * from "./choosePrivilege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports